export const MODULE_OPTIONS = [
  { value: 'total', label: 'Total (Acceso completo)' },
  { value: 'instituciones', label: 'Instituciones' },
  { value: 'hospital', label: 'Hospital' },
  { value: 'accion_social_municipal', label: 'Accion Social' },
  { value: 'desarrollo_habitacional', label: 'Desarrollo Habitacional' },
  { value: 'emergencia_social', label: 'Emergencia Social' },
  { value: 'secretaria_planificacion_diseno_y_desarrollo_territorial', label: 'Secretaria Planificacion, Diseno y Desarrollo Territorial' },
  { value: 'administracion', label: 'Administracion' },
]

export function normalizeModuloValue(modulo) {
  const value = String(modulo || '').trim().toLowerCase()
  if (!value) return 'all'
  if (value === 'social' || value === 'accion_social') return 'accion_social_municipal'
  if (value === 'admin' || value === 'administracion') return 'administracion'
  if (value === 'institucion') return 'instituciones'
  if (value === 'secretaria_planificacion' || value === 'planificacion_territorial') {
    return 'secretaria_planificacion_diseno_y_desarrollo_territorial'
  }
  return value
}

export function inferCategoryModulo(category) {
  const explicit = normalizeModuloValue(category?.module)
  if (explicit !== 'all') return explicit

  const categoryName = String(category?.name || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()

  if (categoryName.includes('secretaria planificacion') || categoryName.includes('diseno y desarrollo territorial')) {
    return 'secretaria_planificacion_diseno_y_desarrollo_territorial'
  }

  return 'all'
}

export function moduloLabel(modulo) {
  const normalized = normalizeModuloValue(modulo)
  return MODULE_OPTIONS.find((option) => option.value === normalized)?.label || modulo || 'Sin modulo'
}
